export const PARENT_URL = 'parentUrl';
export const WIDGET_KEY = 'widget';

export const REGISTRATION_BUTTON_TITLE_RU = 'registrationButtonTitleRu';
export const REGISTRATION_BUTTON_TITLE_EN = 'registrationButtonTitleEn';

export const DEFAULT_CONFIRMATION_TITLE = (accessPreModeration, eventName) => {
    return accessPreModeration
        ? `Спасибо, ваша заявка на "${eventName}" принята!`
        : `Поздравляем, вы успешно зарегистрированы на мероприятие "${eventName}"!`
};

export const DEFAULT_CONFIRMATION_TEXT = (accessPreModeration, email='{{userEmail}}') => {
    return accessPreModeration
        ? `После одобрения заявки организаторами мероприятия вы получите подтверждение участия на электронный адрес ${email}, указанный в форме регистрации. Если вы не можете найти письмо, проверьте папку Спам или свяжитесь с поддержкой support@comdi.com.`
        : `Подтверждение участия отправлено на электронный адрес ${email}, указанный в форме регистрации. Если вы не можете найти письмо, проверьте папку Спам или свяжитесь с поддержкой support@comdi.com.`
};

export const DEFAULT_BUTTON_REGISTRATION_TEXT = (accessPreModeration) => {
    return accessPreModeration
        ? 'Подать заявку'
        : 'Зарегистрироваться'
};

// WIDGET SETTINGS
export const WIDGET_NAME = 'name';

// Common settings
export const WIDGET_COLUMNS_COUNT = 'columnsCount';
export const WIDGET_BACKGROUND_COLOR = 'backgroundColor';
export const WIDGET_BACKGROUND_OPACITY = 'backgroundOpacityPercent';
export const WIDGET_BACKGROUND_BLUR = 'backgroundBlurSize';
export const WIDGET_ACCENT_COLOR = 'colorAccent';
export const WIDGET_BUTTONS_BORDER_RADIUS = 'buttonsBorderRadiusSize';
export const WIDGET_PRIMARY_BUTTON_TEXT_COLOR = 'primaryButtonTextColor';
export const WIDGET_PRIMARY_BUTTON_FILLED = 'primaryButtonFilled';
export const WIDGET_PRIMARY_BUTTON_BORDER = 'primaryButtonBorderSize';
export const WIDGET_PRIMARY_BUTTON_LOCATION = 'primaryButtonLocation';
export const WIDGET_SECONDARY_BUTTON_TEXT_COLOR = 'secondaryButtonTextColor';
export const WIDGET_SECONDARY_BUTTON_BORDER = 'secondaryButtonBorderSize'; 
export const WIDGET_BUTTONS_HEIGHT = 'buttonsHeightSize';

// Fields styles
export const WIDGET_FIELDS_HEIGHT = 'fieldsHeightSize';
export const WIDGET_FIELDS_PERIMETER_BORDER = 'fieldsPerimeterBorder';
export const WIDGET_FIELDS_BORDER_RADIUS = 'fieldsBorderRadiusSize';
export const WIDGET_FIELD_ERROR_BORDER_RADIUS = 'fieldErrorBorderRadiusSize';
export const WIDGET_FIELDS_BORDER_WIDTH = 'fieldsBorderWidthSize';
export const WIDGET_FIELDS_BORDER_COLOR = 'fieldsBorderColor';
export const WIDGET_FIELDS_BORDER_BLUR = 'fieldsBorderBlurSize';
export const WIDGET_FIELDS_BORDER_OPACITY = 'fieldsBorderOpacityPercent';
export const WIDGET_FIELDS_BACKGROUND_COLOR = 'fieldsBackgroundColor';
export const WIDGET_FIELDS_BACKGROUND_OPACITY = 'fieldsBackgroundOpacityPercent';
export const WIDGET_FIELDS_BACKGROUND_BLUR = 'fieldsBackgroundBlurSize';

// Text
export const WIDGET_TITLE_COLOR = 'titleColor';
export const WIDGET_TITLE_SIZE = 'titleSize';
export const WIDGET_SUBTITLE_COLOR = 'subtitleColor';
export const WIDGET_SUBTITLE_SIZE = 'subtitleSize';
export const WIDGET_INPUT_LABEL_COLOR  = 'inputLabelColor';
export const WIDGET_INPUT_LABEL_SIZE = 'inputLabelSize';
export const WIDGET_PLACEHOLDER_COLOR = 'placeholderColor';
export const WIDGET_PLACEHOLDER_SIZE = 'placeholderSize';
export const WIDGET_INPUT_TEXT_COLOR = 'inputTextColor';
export const WIDGET_INPUT_ERROR_BORDER_COLOR = 'inputErrorBorderColor';
export const WIDGET_INPUT_ERROR_MESSAGE_COLOR = 'inputErrorMessageColor';
export const WIDGET_CHECKBOX_TEXT_COLOR = 'checkboxTextColor';
export const WIDGET_CHECKBOX_TEXT_SIZE = 'checkboxTextSize';
export const WIDGET_CHECKBOX_SIZE = 'checkboxSize';
export const WIDGET_DISCLAIMER_TEXT_COLOR = 'disclaimerTextColor';
export const WIDGET_DISCLAIMER_TEXT_SIZE = 'disclaimerTextSize';

// First screen
export const WIDGET_FIRST_SCREEN_TITLE = 'firstScreenTitle';
export const WIDGET_FIRST_SCREEN_TITLE_HIDDEN = 'firstScreenTitleHidden';
export const WIDGET_FIRST_SCREEN_SUBTITLE = 'firstScreenSubtitle';
export const WIDGET_FIRST_SCREEN_SUBTITLE_HIDDEN = 'firstScreenSubtitleHidden';
export const WIDGET_FIRST_SCREEN_PLACEHOLDERS_HIDDEN = 'firstScreenPlaceholdersHidden';
export const WIDGET_FIRST_SCREEN_LABELS_HIDDEN = 'firstScreenLabelsHidden';
export const WIDGET_FIRST_SCREEN_BUTTON_TEXT = 'firstScreenButtonText';
export const WIDGET_DISCLAIMER_CHECKED = 'disclaimerChecked'

// Second screen
export const WIDGET_SECOND_SCREEN_TITLE = 'secondScreenTitle';
export const WIDGET_SECOND_SCREEN_TITLE_HIDDEN = 'secondScreenTitleHidden';
export const WIDGET_SECOND_SCREEN_TEXT = 'secondScreenText';
export const WIDGET_SECOND_SCREEN_SUBTITLE_HIDDEN = 'secondScreenSubtitleHidden';
export const WIDGET_CALENDAR_BUTTON_HIDDEN = 'calendarButtonHidden';

export const PLACEHOLDERS_HINT = `
    {{userEmail}} - почта зарегистрированного участника,
    {{eventName}} - название мероприятия,
    {{timeStart}} - время начала мероприятия,
    {{timeStop}} - время окончания мероприятия,
    {{dateStart}} - дата начала мероприятия,
    {{dateStop}} - дата окончания мероприятия
`;

// Fields settings
export const IS_LABEL_HIDDEN = 'labelHidden';
export const IS_PLACEHOLDER_HIDDEN = 'placeholderHidden';
